import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./CreateHeader.module.scss";

export default function CreateHeader(props) {
  const { Desc } = props;

  return (
    <>
      <Grid2 className={styles.CreateHeader}>
        <Grid2 className={styles.Desc}>
          {/* <div>•</div> */}
          <div> {Desc}</div>
        </Grid2>
      </Grid2>
    </>
  );
}
